module.exports = __webpack_public_path__ + "img/copyright.389ea0b9.svg";